'use strict';

require('./geocoder.service');

angular.module('far.maps', ['uiGmapgoogle-maps', 'far.maps.geocoder', 'nemLogging'])
.config(function(uiGmapGoogleMapApiProvider){
  uiGmapGoogleMapApiProvider.configure({
      key: 'AIzaSyCrmpvXhsOxOUk2l5MEVMOWTexbTOPkag8',
      libraries: 'geometry,visualization'
  });
});
